import { regionContent } from '@kursk/content/regionContent';
import { SocialCard } from './SocialCard/SocialCard';
import { SocialCard as SocialCardBel } from './SocialCard.bel/SocialCard.bel';
import styles from './Socials.module.scss';
import { themeValue } from "@kursk/themes";
import { VkIconDefault } from "./SocialCard/icons/VkIcon";
import { TgIconDefault } from "./SocialCard/icons/TgIcon";
import { VkIcon } from "@kursk/components/pages/Home/Socials/SocialCard.bel/VkIcon";
import { TgIcon } from "@kursk/components/pages/Home/Socials/SocialCard.bel/TgIcon";
import { checkSocials } from "@kursk/utils/socials";
import { MaxIconDefault } from "@kursk/components/pages/Home/Socials/SocialCard/icons/MaxIcon/MaxIcon";

const getGroupId = (link) => {
  if (!link) return '';

  const id = link.split("/").pop();
  return `@${id}`;
};

const getGroupUrl = (url) => {
  if (!url) return '';

  const urlObj = new URL(url);
  return urlObj.host + urlObj.pathname;
}

export function Socials() {
  const { socials, socialTitles } = regionContent;

  return checkSocials() ? (
    <div className={styles.wrapper}>
      {themeValue({
        bel: <SocialCardBel
          title={socialTitles?.vk}
          groupId={getGroupUrl(socials?.vk)}
          icon={<VkIcon />}
          href={socials?.vk}
        />,
        default: <SocialCard
          title={socialTitles?.vk}
          groupId={getGroupId(socials?.vk)}
          icon={<VkIconDefault />}
          href={socials?.vk}
        />
      })}
      {themeValue({
        bel: <SocialCardBel
          title={socialTitles?.telegram}
          groupId={getGroupUrl(socials?.telegram)}
          icon={<TgIcon />}
          href={socials?.telegram}
        />,
        default: <SocialCard
          title={socialTitles?.max || socialTitles?.telegram}
          groupId={getGroupId(socials?.max || socials?.telegram)}
          icon={socials?.max ? <MaxIconDefault /> : <TgIconDefault />}
          href={socials?.max || socials?.telegram}
        />
      })}
    </div>
  ) : null;
}
